import DataTable from './DataTable';
import { HEAT_CLASSES, heatLevel, gridRange } from '../lib/metrics';

/**
 * Heatmap composed from twreact Table: one row per `rowKey`, one cell per
 * column, the cell tinted by its value through token-backed Tailwind classes.
 * (twreact-ui has no heatmap component.)
 */
export default function Heatmap({ rows, rowKey, rowLabel, columns, format = (v) => v, legend }) {
  const { min, max } = gridRange(rows, columns, (r, c) => r[c]);
  const tableColumns = [
    { key: rowKey, label: rowLabel, render: (r) => <span className="font-medium">{r[rowKey]}</span> },
    ...columns.map((c) => ({ key: c, label: c, render: (r) => <span className="tabular-nums">{format(r[c])}</span> })),
  ];
  const cellClass = ({ row, column }) => (column.key === rowKey ? '' : `text-center ${HEAT_CLASSES[heatLevel(row[column.key], min, max)]}`);
  return (
    <div className="space-y-2">
      <DataTable data={rows} columns={tableColumns} cellClass={cellClass} sortable={false} />
      <div className="flex flex-wrap items-center gap-2 text-xs opacity-80" aria-hidden="true">
        <span>{legend || 'Low'}</span>
        {HEAT_CLASSES.map((c) => <span key={c} className={`inline-block h-3 w-6 rounded ${c}`} />)}
        <span>High</span>
      </div>
    </div>
  );
}
